<div *ngIf="user">
<h2 class="text-center"> Editing General Information</h2>
<table class="table">
  <thead>
    <th></th>
    <th></th>
  </thead>
  <tbody>
    <tr>
      <td>First name</td><td>{{user.firstname}}</td>
    </tr>
    <tr>
      <td>Last Name</td><td>{{user.lastname}}</td>
    </tr>
  </tbody>
</table>
<div *ngIf="user" class="text-center">
  <a [routerLink]="['/user/access/edit',user.server_user_id]" class="btn btn-primary me-2">Edit Access Info</a>
  <a [routerLink]="['/user/password/edit',user.server_user_id]" class="btn btn-primary">Edit Password Info</a>
</div>
<div *ngIf="update_success" class="alert alert-info text-center mb-3"> Update Success</div>
<form [formGroup]="userEditForm" (ngSubmit)="on_submit()" *ngIf="user.server_user_id!=0">
<div class="tab-pane" id='tabProfile' *ngIf="user.server_user_id!=0">
  <div class="form-group row" [ngClass]="{error:f.firstName.errors && f.firstName.touched}">
    <label for="firstName" class='control-label col-sm-3'>First Name
      <span class="required-asteric">*</span>
    </label>
    <div class="input-group controls col-sm-8">
      <input type="text" id="firstName" formControlName="firstName" class="form-control">
    </div>
    <div *ngIf="f.firstName.errors && f.firstName.touched">
      <ul>
        <li>First Name Required.</li>
      </ul>
    </div>
  </div>
  <div class="form-group row" [ngClass]="{error:f.lastName.errors && f.lastName.touched}">
    <label for="lastName" class='control-label col-sm-3'>Last Name
      <span class="required-asteric">*</span>
    </label>
    <div class="input-group controls col-sm-8">
      <input type="text" id="lastName" formControlName="lastName" class="form-control">
    </div>
    <div *ngIf="f.lastName.errors && f.lastName.touched">
      <ul>
        <li>Last Name Required.</li>
      </ul>
    </div>
  </div>
  <div class="form-group row" [ngClass]="{error:f.username.errors && f.username.touched}">
    <label for="username" class='control-label col-sm-3'>Email<span class="required-asteric">*</span></label>
    <div class="input-group controls col-sm-8">
      <input type="text" id="username" formControlName="username" class="form-control">
    </div>
    <div *ngIf="f.username.errors && f.username.touched">
      <ul>
        <li>Email is required.</li>
      </ul>
    </div>
  </div>
  <div class="form-group row" [ngClass]="{error:f.officeNumber.errors && f.officeNumber.touched}">
    <label for="officeNumber" class='control-label col-sm-3'>Office Number</label>
    <div class="input-group controls col-sm-8">
      <input type="text" id="officeNumber" formControlName="officeNumber" class="form-control">
    </div>
    <div *ngIf="f.officeNumber.errors && f.officeNumber.touched">
      <ul>
        <li>office Number is required.</li>
      </ul>
    </div>
  </div>

  <div class="form-group row" [ngClass]="{error:f.mobileNumber.errors && f.mobileNumber.touched}">
    <label for="mobileNumber" class='control-label col-sm-3'>Mobile Number</label>
    <div class="input-group controls col-sm-8">
      <input type="text" id="mobileNumber" formControlName="mobileNumber" class="form-control">
    </div>
    <div *ngIf="f.mobileNumber.errors && f.mobileNumber.touched">
      <ul>
        <li>Mobile Number is required.</li>
      </ul>
    </div>
  </div>

</div>


<fieldset class="buttons text-center">
  <button type="submit" class="btn btn-primary margin-50-right">Submit</button>
  <a *ngIf="gatePass.is_role_guardian" [routerLink]="['/guardian/show',guardian.server_user_id]"
    class="btn btn-danger" data-dismiss="modal">Close
  </a>
  <a *ngIf="gatePass.is_role_admin" [routerLink]="['/home/admin/show']" class="btn btn-danger">Close</a>
</fieldset>
</form>
</div>
